import { DefaultService } from '@/services/DefaultService';

export default class AssCampanhaProdutoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

  findByIdProduto(column, order, page = 0, limit = 50, idproduto, situacao, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/produto/asscampanhaproduto/getByProdutos.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

  findCampanhasNaoAssociadosProduto(column, order, page = 0, limit = 50, idproduto, ...params) {
    return this._http.get( encodeURI(`${this._env}/ven/produto/asscampanhaproduto/getnaoassociados.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&param=${params}`), this._headers ).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    save(form) {
    return this._http.post(`${this._env}/ven/produto/asscampanhaproduto`, form, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    updateSituacao(campanhaproduto) {
        return this._http.post(`${this._env}/ven/produto/asscampanhaproduto/updatesituacao`, campanhaproduto, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }

    getById(idcampanhaproduto) {
        return this._http.get(`${this._env}/ven/produto/asscampanhaproduto/getbyid.json?idcampanhaproduto=${idcampanhaproduto}`, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
}